import { AuthService } from 'src/app/core/services/auth.service';
import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { AddPublicLibraryModalComponent } from './modal/add-public-library-modal/add-public-library-modal.component';
import { SettingAdditionalPublicLibraryComponent } from './modal/setting-additional-public-library/setting-additional-public-library.component';
import { AdditionalPublicLibraryService } from 'src/app/core/services/additional-public-library.service';
import { environment } from 'src/environments/environment';
import { RemoveContent } from '../../private-library/remove-content/remove-content.component';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { QrCodeModalComponent } from './modal/qr-code-modal/qr-code-modal.component';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { UploadSpaceModalComponent } from '../../wipod/upload-publication/upload-space-modal/upload-space-modal.component';

@Component({
  selector: 'app-additional-public-library-home',
  templateUrl: './additional-public-library-home.component.html',
  styleUrls: ['./additional-public-library-home.component.scss']
})
export class AdditionalPublicLibraryHomeComponent implements OnInit {

  isLoading = false;
  publicationType = false;
  currentuser: any;
  additonalLibs = [];
  imagePath = environment.url;
  file: File;
  imageSizeError: boolean = false;
  isImageError: boolean = false;
  imgURL;
  currentUser;
  @Input() currentAdditionalAddon;

  constructor(
    private modalService: NgbModal,
    private activeModal: NgbActiveModal,
    private router: Router,
    public authService: AuthService,
    private additonalService: AdditionalPublicLibraryService,
    private _spinner: NgxSpinnerService,
  ) {

  }

  ngOnInit() {
    this.currentUser = this.authService.getCurrentUser();
    // this.router.navigate(['/']);
    this.loadAdditonalPublicLibraries();
  }
  closeDialog() {
    this.activeModal.close();
  }

  ngOnChanges(changes?: SimpleChanges) {
    // if(this.currentAdditionalAddon && this.currentAdditionalAddon.status != 'active'){
    //   this.additionalAddonExpired();
    // }
  }

  loadAdditonalPublicLibraries() {
    this.isLoading = true;
    this._spinner.show();
    this.additonalService.getAdditionalPublicLibrary().subscribe((response) => {
      this.isLoading = false;
      this._spinner.hide();
      if (response.success) {

        this.additonalLibs = response.data.user_outlets;
        if (this.additonalLibs.length > 0) {
          this.publicationType = true;
        }
      }
    }, (error) => {
      this.isLoading = false;
      this._spinner.hide();
    });
  }

  openAddSupplementary() {

    if ((this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentAdditionalAddon && this.currentAdditionalAddon.status != 'active') || (!this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentUser.user.last_plan.plan.additional_libraries_allowed && this.currentAdditionalAddon)) {
      this.additionalAddonExpired();
      return;
    }

    // this.closeDialog();
    const modalRef = this.modalService.open(AddPublicLibraryModalComponent, { size: 'lg', centered: true, backdrop: 'static', windowClass: "google-address" });
    modalRef.result.then((data) => {
      if (data == 'success') {
        this.loadAdditonalPublicLibraries();
      }
    });
  }

  openEditSupplementary(user) {
    if ((this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentAdditionalAddon && this.currentAdditionalAddon.status != 'active') || (!this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentUser.user.last_plan.plan.additional_libraries_allowed && this.currentAdditionalAddon)) {
      this.additionalAddonExpired();
      return;
    }
    const modalRef = this.modalService.open(AddPublicLibraryModalComponent, { size: 'lg', centered: true, backdrop: 'static' });
    modalRef.componentInstance.user = user;
    modalRef.result.then((response) => {
      if (response) {
        this.ngOnInit();
      }
    });
  }

  openChangeSupplementarySetting(user) {
    if ((this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentAdditionalAddon && this.currentAdditionalAddon.status != 'active') || (!this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentUser.user.last_plan.plan.additional_libraries_allowed && this.currentAdditionalAddon)) {
      this.additionalAddonExpired();
      return;
    }
    const modalRef = this.modalService.open(SettingAdditionalPublicLibraryComponent, { size: 'lg', centered: true });
    modalRef.componentInstance.user = user;
  }

  openPublicLibrary(id) {
    if ((this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentAdditionalAddon && this.currentAdditionalAddon.status != 'active') || (!this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentUser.user.last_plan.plan.additional_libraries_allowed && this.currentAdditionalAddon)) {
      this.additionalAddonExpired();
      return;
    }
    this.router.navigate(['/public-library-content', id])
  }

  openDeleteAdditionalLib(userId) {
    if ((this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentAdditionalAddon && this.currentAdditionalAddon.status != 'active') || (!this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentUser.user.last_plan.plan.additional_libraries_allowed && this.currentAdditionalAddon)) {
      this.additionalAddonExpired();
      return;
    }
    const modalRef = this.modalService.open(RemoveContent, { centered: true });
    modalRef.componentInstance.message = "Are you sure you want to delete this public library?";
    modalRef.componentInstance.title = "Delete Public Library";
    modalRef.result.then((data) => {
      if (data === 'success') {
        this._spinner.show();
        this.additonalService.deleteAdditionalPublicLibrary(userId).subscribe((response) => {
          this._spinner.hide();
          this.isLoading = false;
          if (response.success) {
            this.loadAdditonalPublicLibraries();
            const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            modalRef.componentInstance.message = "Public library deleted successfully";
          } else {
            const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
            modalRef.componentInstance.message = "Error occured during deleting public library";
          }
        }, (error) => {
          this._spinner.hide();
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = "Error occured during deleting public library";
          this.isLoading = false;
        });
      }
    });
  }

  assignClick(event, userId) {
    if ((this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentAdditionalAddon && this.currentAdditionalAddon.status != 'active') || (!this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentUser.user.last_plan.plan.additional_libraries_allowed && this.currentAdditionalAddon)) {
      this.additionalAddonExpired();
      return;
    }
    document.getElementById('file' + userId).click();
  }

  preview(files, user) {
    if ((this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentAdditionalAddon && this.currentAdditionalAddon.status != 'active') || (!this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentUser.user.last_plan.plan.additional_libraries_allowed && this.currentAdditionalAddon)) {
      this.additionalAddonExpired();
      return;
    }
    if (files.length === 0)
      return;

    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
      modalRef.componentInstance.message = "Only images are supported.";
      this.isImageError = true;
      return;
    }

    if (mimeType !== 'image/png' && mimeType !== 'image/jpeg' && mimeType !== 'image/gif') {
      const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
      modalRef.componentInstance.message = LITERALS.VALIDATION.IMAGE_VALIDATION;
      this.isImageError = true;
      return;
    }
    if (files[0].size / 1048576 > 5.0) {
      const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
      modalRef.componentInstance.message = "File size should be less than 5 MB";
      this.imageSizeError = true;
      return;
    }


    var reader = new FileReader();
    this.file = files[0];
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
      this.saveAvatar(user);
    }
    this.isImageError = false;
    this.imageSizeError = false;
  }

  saveAvatar(user) {
    if ((this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentAdditionalAddon && this.currentAdditionalAddon.status != 'active') || (!this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentUser.user.last_plan.plan.additional_libraries_allowed && this.currentAdditionalAddon)) {
      this.additionalAddonExpired();
      return;
    }
    if (!this.imgURL) {
      return;
    }
    this._spinner.show();
    const params = {
      avatar: this.file
    }
    this.additonalService.editAdditionalPublicLibrary(params, user.id).subscribe((response) => {
      this.loadAdditonalPublicLibraries();
      this._spinner.hide();
      if (response.success) {
        const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        modalRef.componentInstance.message = "Profile picture updated successfully";
      } else {
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = "Error occured during updating profile picture";
      }
    }, (error) => {
      this._spinner.hide();
      this.loadAdditonalPublicLibraries();
      const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
      modalRef.componentInstance.message = "Error occured during updating profile picture";
    });
  }

  openQRCode(user) {
    if ((this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentAdditionalAddon && this.currentAdditionalAddon.status != 'active') || (!this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentUser.user.last_plan.plan.additional_libraries_allowed && this.currentAdditionalAddon)) {
      this.additionalAddonExpired();
      return;
    }
    const modalRef = this.modalService.open(QrCodeModalComponent, { centered: true });
    modalRef.componentInstance.user = user;
    modalRef.result.then((data) => {
      this.loadAdditonalPublicLibraries();
    }, (reason) => {
      this.loadAdditonalPublicLibraries();
    });
  }

  additionalAddonExpired() {
    const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
    modalRef.componentInstance.contentAccessError = (!this.currentUser.user.subscription.plan.additional_libraries_allowed && this.currentUser.user.last_plan.plan.additional_libraries_allowed) ? LITERALS.AUTH.ERROR_MESSAGES.ADDITIONAL_PUBLIC_LIB_PLAN_EXPIRED : LITERALS.AUTH.ERROR_MESSAGES.ADDITIOAL_PUBLIC_LIBRARY_ADDON_EXPIRED_OWNER;
    modalRef.componentInstance.isRedirectRequired = false;
  }
}
